import { useTranslation } from "@/context/TranslationContext";
import styles from "./Skills.module.scss";

export default function Skills() {
  const { t } = useTranslation();

  const skillCategories = [
    {
      title: "SKILLS.FRONTEND.TITLE",
      icon: "bx bx-code-alt",
      description: "Moderne Web-Interfaces",
      skills: [
        { name: "React", icon: "bx bxl-react" },
        { name: "Angular", icon: "bx bxl-angular" },
        { name: "TypeScript", icon: "bx bxl-typescript" },
        { name: "UI/UX", icon: "bx bx-palette" },
        { name: "SEO", icon: "bx bx-search" },
      ],
    },
    {
      title: "SKILLS.BACKEND.TITLE",
      icon: "bx bx-server",
      description: "Robuste API-Entwicklung",
      skills: [
        { name: "Java", icon: "bx bxl-java" },
        { name: "Spring Boot", icon: "bx bxl-spring-boot" },
        { name: "Python", icon: "bx bxl-python" },
        { name: "Node.js", icon: "bx bxl-nodejs" },
      ],
    },
    {
      title: "SKILLS.MOBILE.TITLE",
      icon: "bx bx-mobile-alt",
      description: "Native & Cross-Platform",
      skills: [
        { name: "React Native", icon: "bx bxl-react" },
        { name: "iOS", icon: "bx bxl-apple" },
        { name: "Android", icon: "bx bxl-android" },
      ],
    },
    {
      title: "SKILLS.CLOUD.TITLE",
      icon: "bx bx-cloud",
      description: "Skalierbare Infrastruktur",
      skills: [
        { name: "Amazon Web Services", icon: "bx bx-cloud" },
        { name: "Microsoft Azure", icon: "bx bx-cloud" },
        { name: "Google Cloud", icon: "bx bx-cloud" },
        { name: "Datenbanken", icon: "bx bx-data" },
      ],
    },
  ];

  return (
    <section id="skills" className={styles.skills}>
      <div className={styles.container}>
        <div className={styles.header} data-aos="fade-up">
          <h2 className={styles.sectionTitle}>{t("SKILLS.TITLE")}</h2>
        </div>
        <div className={styles.skillsGrid}>
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className={styles.categoryCard}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.cardHeader}>
                <div className={styles.iconWrapper}>
                  <i className={category.icon}></i>
                </div>
                <div className={styles.headerContent}>
                  <h3>{t(category.title)}</h3>
                  <p className={styles.categoryDescription}>
                    {category.description}
                  </p>
                </div>
              </div>
              <div className={styles.skillsTags}>
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className={styles.skillTag}>
                    <i className={skill.icon}></i>
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
